import { createFileRoute } from '@tanstack/react-router';
import { WorkplaceTab } from '@/features/account/workplace/WorkplaceTab';

export const Route = createFileRoute('/account/lieu-de-travail/')({
  component: WorkplaceTab,
});
